
import ViewModel from './viewmodel';
import { getRandom } from './utils';
import { update } from 'lodash';
// import deepClone from './deepClone';

/**
 * @namespace SpaCache
 */

function _getRunContext() {
    return window.__QIANKUN_RUNCONTEXT?.runContext;
}

function _getData(dataSource, _runContext) {
    return ViewModel.getData(dataSource, _runContext || _getRunContext());
}
function _setData(dataSource, value, _runContext) {
    ViewModel.setData(dataSource, value, _runContext || _getRunContext());
}

const maxCacheLen = 5001;

// 列表缓存 500 条
// 卡片也缓存 500 条
// 列表和卡片缓存数据跟用户操作有关系
// 列表下有顺序
// 卡片缓存数据没有顺序
// cardCachePks: 记录卡片缓存的pk;

/**
 * cardData参数说明
 * @memberof SpaCache
 * @typedef cardData
 * @property {Object} head={headAreaCode:{rows:[{values:{}}]}} 表头数据
 * @property {Object} body/bodys 表体数据
*/

/**
 * headData参数说明
 * @memberof SpaCache
 * @typedef headData
 * @property {Object} attrcode={display, value} 具体字段值
*/

/**
 * 卡片界面删除前获取下一个pk值
 * @memberof SpaCache
 * @param {string} pkvalue 当前pk值
 * @param {string} dataSource 单页缓存的命名空间
 * @param {boolean} isUseDel=true 是否是删除场景下使用。默认删除场景，即若当前pk是最后一条，则返回第一条的pk值；若isUseDel=false,不是删除场景，若当前pk是最后一条，则返回null。
 * @returns {string}
 */
//获取删除后下一条列表当前页页面数据的id
function getNextId(pkvalue, dataSource, isUseDel = true) {
    if (pkvalue && dataSource) {
        let listData = _getData(dataSource);
        let currentpks = [];
        if (listData && listData.simpleTable) {
            currentpks = [...new Set(listData.simpleTable.currentpks)];
        }
        if (currentpks && currentpks.length > 1) {
            let index = currentpks.indexOf(pkvalue);
            if (index == currentpks.length - 1) {
                if (!isUseDel) { //非删除场景 是最后一条 返回null
                    return null;
                }
                //删除场景:是最后一条,返回上一条
                listData.currentId = currentpks[currentpks.length - 2];
                _setData(dataSource, listData);
                return currentpks[currentpks.length - 2];
            } else { //不是最后一条,返回下一条
                listData.currentId = currentpks[index + 1];
                _setData(dataSource, listData);
                return currentpks[index + 1];
            }

        } else {
            if (listData) {
                listData.currentId = null;
            }
            return null;
        }
    }
}

// 根据pk, 差异化更新 原列表、卡片缓存的表头数据
/**
 * 内部使用：在卡片界面，收到socket消息后，更新列表缓存数据
 */
function updateHeadCache(dataSource, pkvalue, headAreacode, updateValues) {
    let mcData = _getData(dataSource);
    if (!mcData) { return; }

    let simpleTableValues = null;
    //根据pk 找到列表对应数据
    if (mcData.simpleTable && mcData.simpleTable.currentpks) {
        //更新列表当前页数据
        let index = mcData.simpleTable.currentpks.indexOf(pkvalue);
        if (index !== -1) {
            simpleTableValues = mcData.simpleTable.rows[index].values;
        }
    }
    if (mcData.card && mcData.card[pkvalue]) {
        let head = mcData.card[pkvalue].head;
        let headValues = head && head[headAreacode] && head[headAreacode].rows[0].values;
        headValues && Object.keys(updateValues).forEach((pop, index) => {
            //更新卡片表头数据
            if (headValues[pop]) {
                headValues[pop].value = updateValues[pop];
            }

            //更新对应的列表当前页数据
            if (simpleTableValues && simpleTableValues[pop]) {
                simpleTableValues[pop].value = updateValues[pop];
            }
        });
        _setData(dataSource, mcData);
    }
}

/**
 * 根据pk, 差异化更新 原列表、卡片缓存的表头数据
 * 内部使用：在卡片界面，收到socket消息后，更新列表缓存数据
 */
function newUpdateHeadCache(dataSource, pkname, headAreacode, updateRows) {
    let mcData = _getData(dataSource);
    if (!mcData) { return; }
    //逐条更新缓存的卡片表头、表格当前页数据
    updateRows.forEach((updateValues, index) => {
        let pkvalue = updateValues[pkname];
        let simpleTableValues = null;
        //根据pk 找到列表对应数据
        if (mcData.simpleTable && mcData.simpleTable.currentpks) {
            //更新列表当前页数据
            let index = mcData.simpleTable.currentpks.indexOf(pkvalue);
            if (index !== -1) {
                simpleTableValues = mcData.simpleTable.rows[index].values;
            }
        }
        if (mcData.card && mcData.card[pkvalue]) {
            let head = mcData.card[pkvalue].head;
            let headValues = head && head[headAreacode] && head[headAreacode].rows[0].values;

            Object.keys(updateValues).forEach((pop, index) => {
                //更新卡片表头数据
                if (headValues[pop]) {
                    headValues[pop].value = updateValues[pop];
                }
                //更新对应的列表当前页数据
                if (simpleTableValues && simpleTableValues[pop]) {
                    simpleTableValues[pop].value = updateValues[pop];
                }
            });

        }
    });
    _setData(dataSource, mcData);
}

/**
 * 卡片界面根据pk值替换卡片和列表界面对应的缓存数据。比如变更后：原来的pk和数据都变了，需要删除替换旧缓存数据
 * @memberof SpaCache
 * @param {string} dataSource 单页缓存的命名空间
 * @param {string} newPkValue 新pk值
 * @param {string} oldPkValue 旧pk值
 * @param {string} headAreaCode 表头区域编码，用于更新列表缓存数据
 * @param {cardData} newData 新的卡片数据
 */
// 替换缓存中原有 pk 数据； 变更场景下 原单据的 pk 和 数据 都改了
function updatePkCache(dataSource, newPkvalue, oldPkvalue, headAreacode, newData) {
    let mcData = _getData(dataSource);
    if (!mcData) { return; }

    //替换原卡片数据
    if (mcData.card && mcData.card[oldPkvalue]) {
        mcData.card[newPkvalue] = newData;
        delete mcData.card[oldPkvalue];

        let index = mcData.cardCachePks.indexOf(oldPkvalue);
        if (index !== -1) {
            mcData.cardCachePks[index] = newPkvalue;
        }
        //更新当前pk
        mcData.currentId = newPkvalue;
    }

    //替换原列表数据
    if (mcData.simpleTable && mcData.simpleTable.currentpks) {
        //更新列表当前页数据
        let currentpks = mcData.simpleTable.currentpks;
        let indexes = [];
        for (let i = 0; i < currentpks.length; i++) {
            if (currentpks[i] === oldPkvalue) {
                indexes.push(currentpks[i]);
            }
        }
        indexes.forEach(index => {
            mcData.simpleTable.currentpks[index] = newPkvalue;
            if (mcData.simpleTable.rows[index]) {
                mcData.simpleTable.rows[index].values = newData.head[headAreacode].rows[0].values;
            }
        });
        //更新列表allpk数据
        let indexAll = mcData.simpleTable.allpks.indexOf(oldPkvalue);
        if (indexAll !== -1) { mcData.simpleTable.allpks[indexAll] = newPkvalue; }
        //更新列表cacheAllPks数据
        let cacheAllPks = mcData.simpleTable.cacheAllPks || mcData.simpleTable.allpks;
        let indexCacheAll = cacheAllPks.indexOf(oldPkvalue);
        if (indexAll !== -1) { cacheAllPks[indexCacheAll] = newPkvalue; }
    }
    _setData(dataSource, mcData);
}

/**
 * 卡片界面根据pkname和pkvalue的值更新卡片和列表界面对应的缓存数据。使用场景：修改保存
 * @memberof SpaCache
 * @param {string} pkName pk字段名  不一定是主键
 * @param {string} pkValue 新pk值
 * @param {cardData} newData 更新后的卡片数据
 * @param {string} headAreaCode 表头区域编码，用于更新列表缓存数据
 * @param {string} dataSource 单页缓存的命名空间
 * @param {headData} headData 非必输，只用于替换列表缓存
 */
function updateCache(pkname, pkvalue, newData, headAreacode, dataSource, headData, _runContext) {
    if (!dataSource || !pkvalue) {
        return;
    }

    if (newData) {
        newData = JSON.parse(JSON.stringify(newData));
    }

    if (headData) {
        headData = JSON.parse(JSON.stringify(headData));
    }

    let updatedData = headData ?? newData?.head?.[headAreacode]?.rows?.[0]?.values ?? {};

    let mcData = _getData(dataSource, _runContext);

    // 初始化缓存
    if (!mcData) {
        mcData = {
            card: {},
            cardCachePks: [],
            currentId: '',
            simpleTable: null,
        };
    }

    // 初始化列表缓存
    if (!mcData.simpleTable?.rows?.length) {
        // 因为updateCache里没有新增主表的逻辑，所以初始化时要默认带上一条数据
        mcData.simpleTable = {
            ...mcData.simpleTable,
            rows: [{
                rowId: getRandom(),
                values: updatedData,
            }],
            currentpks: [pkvalue],
            allpks: [pkvalue],
            cacheAllPks: [pkvalue],
            cacheAllBodyPks: [],
            alltss: [],
            next: [],
        };
    }

    // 初始化卡片缓存
    if (!mcData.card) {
        mcData.card = {};
        mcData.cardCachePks = [];
    }

    // 卡片新增数据
    if (!mcData.card[pkvalue]) {
        mcData.cardCachePks.push(pkvalue);
        // 达到最大缓存数时，删除第一条
        if (mcData.cardCachePks.length === maxCacheLen) {
            let firstPkvalue = mcData.cardCachePks.shift();
            delete mcData.card[firstPkvalue];
        }
    }
    mcData.card[pkvalue] = newData;

    // 设置当前id
    mcData.currentId = pkvalue;

    /**
     * 下面开始和addCache不一样
     */
    let simpleTable = mcData.simpleTable;

    // TODO: pkname为数组的情况不知道谁再用，知道了的话记录一下
    if (Array.isArray(pkname) && Array.isArray(pkvalue) && pkname.length == 2 && pkvalue.length == 2) {
        simpleTable.rows = simpleTable.rows.map(item => {
            if (
                item.values?.[pkname[0]]?.value === pkvalue[0] &&
                item.values?.[pkname[1]]?.value === pkvalue[1]
            ) {
                item.values = { ...item.values, ...updatedData };
            }
            return item;
        });
    } else {
        simpleTable.rows = simpleTable.rows.map(item => {
            if (item.values?.[pkname]?.value === pkvalue) {
                //已含有该数据，对数据更新
                item.values = { ...item.values, ...updatedData };
            }
            return item;
        });
    }

    //更新列表数据
    mcData.simpleTable = simpleTable;

    if (!mcData.simpleTable.next) {
        mcData.simpleTable.next = [];
    }

    mcData.simpleTable.next.push({
        type: 'update',
        pkvalue,
        head: { values: updatedData },
        bodys: newData?.body ?? newData?.bodys ?? {},
    });

    _setData(dataSource, mcData, _runContext);
}

/**
 * 卡片界面根据pk值新增卡片和列表界面对应的缓存数据。使用场景：新增保存
 * @memberof SpaCache
 * @param {string} pkValue pk字段名
 * @param {cardData} newData 更新后的卡片数据
 * @param {string} headAreaCode 表头区域编码，用于更新列表缓存数据
 * @param {string} dataSource 单页缓存的命名空间
 * @param {headData} headData 非必输，只用于替换列表缓存
 */
function addCache(pkvalue, newData, headAreacode, dataSource, headData) {
    if (!dataSource || !pkvalue) {
        return;
    }

    if (newData) {
        newData = JSON.parse(JSON.stringify(newData));
    }

    if (headData) {
        headData = JSON.parse(JSON.stringify(headData));
    }

    // 要插入的行数据
    let addedRow = headData ?? newData?.head?.[headAreacode]?.rows?.[0]?.values ?? {};

    // 处理缓存数据
    let mcData = _getData(dataSource);

    // 初始化缓存
    if (!mcData) {
        mcData = {
            card: {},
            cardCachePks: [],
            currentId: '',
            simpleTable: null,
        };
    }

    // 初始化列表缓存
    if (!mcData.simpleTable?.rows?.length) {
        mcData.simpleTable = {
            ...mcData.simpleTable,
            rows: [],
            currentpks: [],
            allpks: [],
            cacheAllPks: [],
            cacheAllBodyPks: [],
            alltss: [],
            next: [],
        };
    }

    // 初始化卡片缓存
    if (!mcData.card) {
        mcData.card = {};
        mcData.cardCachePks = [];
    }

    // 卡片新增数据
    if (!mcData.card[pkvalue]) {
        mcData.cardCachePks.push(pkvalue);
        // 达到最大缓存数时，删除第一条
        if (mcData.cardCachePks.length === maxCacheLen) {
            let firstPkvalue = mcData.cardCachePks.shift();
            delete mcData.card[firstPkvalue];
        }
    }
    mcData.card[pkvalue] = newData;

    // 设置当前id
    mcData.currentId = pkvalue;

    let { simpleTable } = mcData,
        { pageInfo = {} } = simpleTable,
        { pageIndex = 0, pageSize = 100 } = pageInfo;

    let index = Number(pageIndex) * Number(pageSize) + Number(simpleTable.rows.length); //主表pk插入位置;

    simpleTable.rows.push({
        values: addedRow,
        rowId: pkvalue,
        _addByCache: true,
    });

    /**
     * 有缓存，且拉平时，index不对
     */
    simpleTable.allpks.splice(index, 0, pkvalue);
    simpleTable.cacheAllPks.splice(index, 0, pkvalue);
    simpleTable.alltss?.splice(index, 0, addedRow.ts?.value);
    simpleTable.currentpks.push(pkvalue);

    //判断列表缓存数据是否到最大限制
    if (simpleTable.currentpks.length === maxCacheLen) {
        //删除列表中第一条
        simpleTable.rows.shift();
        simpleTable.currentpks.shift();
    }

    //更新列表数据
    mcData.simpleTable = simpleTable;

    if (!mcData.simpleTable.next) {
        mcData.simpleTable.next = [];
    }

    mcData.simpleTable.next.push({
        type: 'add',
        pkvalue,
        head: { values: addedRow },
        bodys: newData?.body ?? newData?.bodys ?? {},
    });

    _setData(dataSource, mcData);
}

/**
 * 更新列表界面附件的值。 使用场景：卡片修改附件，领域不会改附件的缓存、平台统一处理。
 * @memberof SpaCache
 * @param {string} pkValue 默认作为附件的值
 * @param {string} newNum  附件的数量
 * @param {string} newValue 附件的值
 */

function updateAttachmentValue(newNum, pkValue, pkName, dataSource, newValue) {
    // if(newNum===undefined ||  !pkValue || !pkName || !dataSource) return;
    // let { targetRowIndex } = getTableInfo(dataSource, pkValue, pkName)||{};
    // if( targetRowIndex!==undefined ) {
    //     let { attachmentCols, rows } = ViewModel.getData(dataSource).simpleTable;

    //     attachmentCols.forEach(col=>{
    //         let attachmentValue = rows[targetRowIndex].values[col.attrcode];
    //         if(attachmentValue.value===undefined) {
    //             attachmentValue.value = `${newNum},${ newValue || pkValue}`;
    //         } else {
    //             let [, value] = attachmentValue.value.split(',');
    //             attachmentValue.value = `${newNum},${value}`;
    //         }
    //     });
    // }
}
/**
 * @param {string} pkvalue  单据主键
 * @param {string} dataSource  缓存表数据的key
 */
function getTableInfo(dataSource, pkValue) {
    let tableData = ViewModel.getData(dataSource)?.simpleTable || {};
    let tableInfo = {};

    let { pkname, rows = [] } = tableData;
    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        if (rows[rowIndex].values[pkname].value === pkValue) {
            tableInfo.targetRowIndex = rowIndex;
            break;
        }
    }

    return tableInfo;
}

/**
 * 卡片界面判断是否有卡片缓存数据。场景：是：使用缓存数据;否：请求后台
 * @memberof SpaCache
 * @param {string} pkValue pk字段值
 * @param {string} dataSource 单页缓存的命名空间
 * @returns {Object} 
 */
function getCacheById(pkvalue, dataSource) {
    if (dataSource) {
        let mcData = _getData(dataSource);
        if (mcData && mcData.card && mcData.card[pkvalue]) {
            mcData.currentId = pkvalue;
            _setData(dataSource, mcData);
            return JSON.parse(JSON.stringify(mcData.card[pkvalue]));
        }
    }
    return null;
}

/**
 * 卡片界面：根据pk删除对应的卡片和列表缓存数据
 * @memberof SpaCache
 * @param {string} pkName pk字段名
 * @param {string} pkValue pk字段值
 * @param {string} dataSource 单页缓存的命名空间
 */
function deleteCacheById(pkname, pkvalue, dataSource) {
    if (!dataSource || !pkvalue) {
        return;
    }

    let mcData = _getData(dataSource);

    if (!mcData) {
        return;
    }

    /**
     * 删除该条卡片数据
     */
    delete mcData.card?.[pkvalue];
    mcData.cardCachePks = mcData.cardCachePks?.filter(item => {
        return item !== pkvalue;
    }) ?? [];

    /**
     * 删除该条列表数据
     */
    if (!mcData.simpleTable) {
        return;
    }

    let simpleTable = mcData.simpleTable;
    // 删除checkedInfo里的缓存checkedKeys
    if (simpleTable.checkedInfo) {
        let { allCheckedKeys = new Set(), checkedKeys = new Set() } = simpleTable.checkedInfo;
        // 如果当前条被选中了，则删除allCheckedKeys和checkedKeys

        allCheckedKeys.delete(pkvalue);
        checkedKeys.delete(pkvalue);

        simpleTable.rows.forEach(row => {
            if (row.values[pkname]?.value === pkvalue) {
                allCheckedKeys.delete(row.rowId);
                checkedKeys.delete(row.rowId);
            }
        });
    }
    // 删除对应数据
    simpleTable.rows = simpleTable.rows?.filter(item => {
        return item?.values?.[pkname]?.value && item?.values?.[pkname]?.value !== pkvalue;
    }) ?? [];

    // 删除allpks里对应的id 
    simpleTable.allpks = simpleTable.allpks.filter(item => {
        return item !== pkvalue;
    });

    // 删除allpks里对应的id 
    let cacheAllPks = simpleTable.cacheAllPks || simpleTable.allpks;
    simpleTable.cacheAllPks = cacheAllPks.filter(item => {
        return item !== pkvalue;
    });

    // 若该pk在currentpks中，删除掉
    simpleTable.currentpks = simpleTable.currentpks.filter(item => {
        return item !== pkvalue;
    });

    // 更新列表数据
    mcData.simpleTable = simpleTable;

    if (!mcData.simpleTable.next) {
        mcData.simpleTable.next = [];
    }

    mcData.simpleTable.next.push({
        type: 'delete',
        pkvalue, // 主表pk
    });

    _setData(dataSource, mcData);
}

/**
 * 获取当前页最后一条数据 pk
 * @memberof SpaCache
 * @param {string} dataSource 单页缓存的命名空间
 * @returns {string} 
 */
function getCurrentLastId(dataSource) {
    if (dataSource) {
        let mcData = _getData(dataSource);
        if (mcData && mcData.simpleTable) {
            let currentpks = mcData.simpleTable.currentpks;
            if (Array.isArray(currentpks) && currentpks.length) {
                mcData.currentId = currentpks[currentpks.length - 1];
                _setData(dataSource, mcData);
                return currentpks[currentpks.length - 1];
            }
        }
    }
    return null;
}

/**
 * 获取当前页某行数据的pk
 * @memberof SpaCache
 * @param {string} dataSource 单页缓存的命名空间
 * @param {number} index 数据行
 * @returns {string} 
 */
function getCurrentIdByIndex(dataSource, index = 0) {
    if (dataSource) {
        let mcData = _getData(dataSource);
        if (mcData && mcData.simpleTable) {
            let currentpks = mcData.simpleTable.currentpks;
            if (Array.isArray(currentpks) && currentpks.length) {
                return currentpks[index];
            }
        }
    }
    return null;
}

/**
 * 获取当前激活 pk
 * @memberof SpaCache
 * @param {string} dataSource 单页缓存的命名空间
 * @returns {string} 
 */
function getCurrentId(dataSource) {
    if (!dataSource) { return; }
    let mcData = _getData(dataSource);
    if (mcData && mcData.currentId) {
        return mcData.currentId;
    }
    return null;
}

/**
 * 缓存自定义数据
 * @memberof SpaCache
 * @param {string} key 单页数据主键
 * @param {string} dataSource 缓存数据的命名空间
 * @param {Object | string | number | boolean} data 缓存数据
 */
function setDefData(key, dataSource, data) {
    ViewModel.setComponentState(key, dataSource, data, _getRunContext());
}

/**
 * 获取缓存的自定义数据
 * @memberof SpaCache
 * @param {string} key 单页数据主键
 * @param {string} dataSource 缓存数据的命名空间
 * @returns {Object | string | number | boolean} 
 */
function getDefData(key, dataSource) {
    return ViewModel.getComponentState(key, dataSource, _getRunContext());
}

/**
 * ListTableCacheData参数说明
 * @memberof SpaCache
 * @typedef ListTableCacheData
 * @property {Array} allpks 列表所有pk组成的数组
 * @property {Array} currentpks 当前页pk组成的数组
 * @property {Array} rows 列表当前页数据
 * @property {Object} pageInfo 列表分页信息
*/

/**
 * 自定义设置列表缓存数据
 * @memberof SpaCache
 * @param {string} dataSource 缓存数据的命名空间
 * @param {ListTableCacheData} data 缓存的列表数据
 */
function setListDefCache(dataSource, data) {

    // cacheData = {
    //     allpks,
    //     cacheAllPks,
    //     currentpks,
    //     rows,
    //     pageInfo,
    //     checkInfo,
    //     currentInfo,
    //     alltss,
    //     props,
    //     modelDatas,
    //     sortParam,
    //     config,
    //     scrollTop,
    //     cacheCurrentIndex,
    //     filter: {
    //         filterReset: store.getStore('filterReset'),
    //         defaultAfterFilterFactors: store.getStore('defaultAfterFilterFactors'),
    //         defaultLogicOverviewValue: store.getStore('defaultLogicOverviewValue'),
    //         defaultAfterFilterItemList: store.getStore('defaultAfterFilterItemList'),
    //         columnStatus: store.getStore('columnStatus'),
    //     },

    _setData(dataSource, { simpleTable: data });
}

/**
 * 获取自定义的列表缓存数据
 * @memberof SpaCache
 * @param {string} dataSource 缓存数据的命名空间
 * @returns {Object} 
 */
function getListDefCache(dataSource) {
    return (_getData(dataSource) || {}).simpleTable;
}

export {
    getNextId,
    updateCache,
    updateHeadCache,
    newUpdateHeadCache,
    updatePkCache,
    addCache,
    // updateAttachmentValue,
    getCacheById,
    deleteCacheById,
    getCurrentLastId,
    getCurrentIdByIndex,
    getCurrentId,
    setDefData,
    getDefData,
    setListDefCache,
    getListDefCache,
};